<template>
  <div class="">
    <button class="btn-indigo w-32 font-normal" @click="openModal()">Card</button>
    <ModalHeadlessUI ref="modal">
      <template #default>
        <h1 class="font-bold mb-4 text-3xl text-center">
          Mail Card
        </h1>
        <div class="px-10">
          <form id="form" name="form" @submit.prevent="sendCard">
            <text-input v-model="form.to" :error="form.errors.to" class="pr-6 pb-4 w-full" label="Addressed To" />
            <text-input v-model="form.address" :zillow="zillow" :error="form.errors.address" class="relative pr-6 pb-4 w-full" label="Address" />
            <text-input v-model="form.city" :error="form.errors.city" class="pr-6 pb-4 w-full" label="City" />
            <text-input v-model="form.state" :error="form.errors.state" class="pr-6 pb-4 w-full" label="State" />
            <text-input v-model="form.zip" :error="form.errors.zip" class="pr-6 pb-4 w-full" label="Zip" />
            <select-input v-model="form.font" class="pr-6 pb-4 w-full" label="Select Handwriting Font">
              <option value="Casual David" selected="selected">Casual David (Dude)</option>
              <option value="Enthusiastic Erin">Enthusiastic Erin (Chick)</option>
            </select-input>
            <select-input v-model="form.message" class="pr-6 pb-4 w-full" label="Select Card Template">
              <option :value="null" />
              <option v-for="cardTemplateSingle in cardTemplateOptions" :key="cardTemplateSingle.id" :value="cardTemplateSingle.value">{{ cardTemplateSingle.name }}</option>
            </select-input>
            <textarea-input v-model="form.message" rows="10" :error="form.errors.message" class="pr-6 pb-4 w-full" label="Message">Card Message</textarea-input>
            <div class="flex justify-center items-center mt-5">
              <div>
                <loading-button :loading="form.processing" class="cursor-pointer btn-indigo ml-auto" type="submit">Send Card</loading-button>
              </div>
            </div>
          </form>
        </div>
      </template>
    </ModalHeadlessUI>
  </div>
</template>

<script>
import ModalHeadlessUI from '@/Shared/ModalHeadlessUI'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import { router } from '@inertiajs/vue3'

export default {
  components: {
    ModalHeadlessUI,
    SelectInput,
    TextareaInput,
    TextInput,
    LoadingButton,
  },
  props: {
    contact:{
      type: Object,
      default: null,
    },
    userInfo:{
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      form: router.form({
        id: this.contact.id,
        type: 'contact',
        to: this.contact.first_name+' '+this.contact.last_name,
        address: this.contact.address,
        city: this.contact.city,
        state: this.contact.region,
        zip: this.contact.postal_code,
        font: 'Casual David',
        message: '',
      }),
    }
  },
  computed:{
    cardTemplateOptions() {
      var cardTemplateOptions= [
        {
          'id': '1',
          'name': 'Check In',
          'value':  this.contact.first_name+',\n\nI wanted to send you a quick card to check in. I hope you are crushing this year! If there is anything I can do to help you grow your business let me know!\n\nSincerely,\n\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+' and the Riverbank Team',
        },
        {
          'id': '2',
          'name': 'Referral',
          'value':  this.contact.first_name+',\n\nThank you for trusting me with a referral. I greatly appreciate you sending clients my way to help with their mortgage!\n\nSincerely,\n\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+' and the Riverbank Team',
        },
        {
          'id': '3',
          'name': 'Nice to Meet You',
          'value':  this.contact.first_name+',\n\nIt was nice to meet you! Let me know if I can help with anything in the future. \n\nTalk to you soon,\n\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+' and the Riverbank Team',
        },
        {
          'id': '4',
          'name': 'Congratulations on Closing',
          'value':  this.contact.first_name+',\n\nCongratulations on a successful closing and a happy client! Thank you for your partnership — I appreciate your collaboration throughout the process. I look forward to working with you again in the future!\n\nTalk to you soon,\n\n'+this.userInfo.user_first_name+' '+this.userInfo.user_last_name+' and the Riverbank Team',
        },
      ]
      return cardTemplateOptions
    },
  },
  methods:{
    openModal() {
      this.$refs.modal.openModal()
    },
    closeModal() {
      this.$refs.modal.closeModal()
    },
    sendCard() {
      this.form.post('/card', {
        onSuccess: () => {
          this.closeModal()
        },
      })
    },
  },
}
</script>
